import { useQuery } from "react-query";

import { autoChecklistService } from "services";

const useGofacResultQuery = ({
	id,
	enabled = true,
}: {
	id: string;
	enabled?: boolean;
}) =>
	useQuery(["gofacResult", id], () => autoChecklistService.getGOFAC(id), {
		retry: 0,
		cacheTime: 0,
		enabled: enabled && !!id,
	});

export default useGofacResultQuery;
